import { LinkIcon } from "@heroicons/react/20/solid";
import { CopyButton } from "../CopyButton";
import history from "../../common/history";

/**
 * The anchor affordance beside a section header (deep-linking design): the
 * anchor icon wrapped in the shared CopyButton, so hover-reveal and copied
 * feedback match the key-value pairs exactly. Clicking copies the full deep
 * link to this section (current canonical URL plus #anchorId) and stamps the
 * fragment onto the address bar, so what the user pastes elsewhere lands
 * exactly here. anchorId must be a hand-assigned id from
 * DashboardSectionAnchors and must sit on the section's container.
 */
const SectionAnchorLink = ({ anchorId, className = "" }) => {
    if (!anchorId) {
        return null;
    }

    // Resolved at click time by CopyButton: reads the live location and stamps
    // the fragment before handing back the full link.
    const sectionLink = () => {
        const { pathname, search } = history.location;
        const pathWithFragment = `${pathname}${search}#${anchorId}`;

        history.replace(pathWithFragment);

        return `${window.location.origin}${pathWithFragment}`;
    };

    return (
        <CopyButton value={sectionLink} className={className}>
            <LinkIcon className="h-4 w-4 text-foreground-subtle opacity-40 group-hover:opacity-100 transition-opacity" />
        </CopyButton>
    );
};

export default SectionAnchorLink;
